import {default as NextLink} from 'next/link';
import {Url} from "next/dist/shared/lib/router/router";
import {useRouter} from "next/router";

export const isExternalURL = (url: string | Url) => {
  if (typeof url === 'string') {
    return !(url?.startsWith('/') || (process?.env?.NEXT_PUBLIC_SITE_URL && url?.startsWith(process.env.NEXT_PUBLIC_SITE_URL)));
  } else if (typeof url?.pathname === 'string') {
    return !(url?.pathname?.startsWith('/') || (process?.env?.NEXT_PUBLIC_SITE_URL && url?.pathname?.startsWith(process.env.NEXT_PUBLIC_SITE_URL)));
  }
};

export function Link({href, children, ...props}) {
  // @todo in case we need to persist urls, add later.
  // const {query} = useRouter();
  // const url: Url = {};
  // if (query?.slug) {
  //   delete query.slug;
  // }
  // if (typeof href === 'string') {
  //   url.pathname = href;
  //   url.query = query;
  // } else if (typeof href === 'object') {
  //   url.pathname = href.pathname;
  //   url.query = href?.query;
  // }

  if (isExternalURL(href)) {
    return (
      <NextLink href={href} {...props} target="_blank" rel="noopener noreferrer">
        {children}
      </NextLink>
    );
  }

  return (
    <NextLink href={href} {...props}>
      {children}
    </NextLink>
  );
}